import React from 'react';
import URC from 'ui-react-common';
import rocketLoansLogo from '../../../node_modules/ui-sdk/source/images/L-RocketLoans-RGB-Horz.svg';

const config = URC.config;
const AppMasthead = URC.ui.components.AppMasthead;
const {
    baseName,
    webUIRoot,
    webUIUrl,
    pingAppUrl,
    rocketAccountLogoutUrl,
    rocketAccountSplitScreenLoginUrl,
    rocketAccountGlobalPreferenceCenterUrl
} = config;

function performLogout() {}

class Masthead extends React.Component {
    constructor(props) {
        super(props);
        if (document.body.classList.contains('logged-in')) {
            this.state = {
                isLoggedIn: true,
                isLoggedIntoRocketAccount: true
            };
        } else {
            this.state = {
                isLoggedIn: false,
                isLoggedIntoRocketAccount: false
            };
        }
        // attach mutation observer to body to detect changes to logged-in class
        const config = { attributes: true, childList: false, subtree: false };
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    if (document.body.classList.contains('logged-in')) {
                        this.setState({
                            isLoggedIn: true,
                            isLoggedIntoRocketAccount: true
                        });
                    } else {
                        this.setState({
                            isLoggedIn: false,
                            isLoggedIntoRocketAccount: false
                        });
                    }
                }
            });
        });
        observer.observe(document.body, config);
    }
    render() {
        return (
            <AppMasthead
                isLoggedIn={this.state.isLoggedIn}
                isLoggedIntoRocketAccount={this.state.isLoggedIntoRocketAccount}
                preClose={false}
                loanDenied={false}
                appRoot={baseName}
                mainAppRoot={webUIRoot + '/'}
                mainAppUrl={webUIUrl}
                pingAppUrl={pingAppUrl}
                logo={rocketLoansLogo}
                rocketAccountLogoutUrl={rocketAccountLogoutUrl}
                rocketAccountSplitScreenLoginUrl={rocketAccountSplitScreenLoginUrl}
                rocketAccountGlobalPreferenceCenterUrl={rocketAccountGlobalPreferenceCenterUrl}
                performLogout={performLogout}
            />
        );
    }
}

export default Masthead;
